import type { MessageCatalog } from "../types";

const sourceSand = "\u2066SOURCE / SAND\u2069";
const pet = "\u2066PET\u2069";
const b2b = "\u2066B2B\u2069";
const cloudflareD1 = "\u2066Cloudflare D1\u2069";

export const ar = {
  language: {
    selectorLabel: "اللغة"
  },
  brand: {
    homeLabel: "الصفحة الرئيسية لـ SOURCE / SAND"
  },
  nav: {
    primaryLabel: "التنقل الرئيسي",
    mobileLabel: "التنقل على الهاتف",
    open: "فتح قائمة التنقل",
    close: "إغلاق قائمة التنقل",
    water: "المياه",
    journey: "الرحلة",
    journal: "اليوميات",
    join: "انضم إلى قائمة التذوق"
  },
  metadata: {
    home: {
      title: "SOURCE / SAND — من بورسيك إلى دبي",
      description:
        "اختبار سوق مستقل في دبي لتحسين الوصول إلى مياه بورسيك المعدنية الطبيعية من رومانيا."
    },
    journal: {
      title: "المياه، من مصادرها — SOURCE / SAND",
      description:
        "ملاحظات موثقة عن المياه المعدنية والمنشأ الروماني ومياه دبي والمسار العملي للاستيراد."
    },
    article: {
      title: "ملاحظة عن المياه — SOURCE / SAND",
      description: `ملاحظة موثقة من ${sourceSand} عن المياه أو المذاق أو المنشأ أو الاستيراد.`
    },
    research: {
      title: "البحث ومعايير القرار — SOURCE / SAND",
      description:
        "المصادر وأدلة السوق وقواعد الادعاءات ومعايير القرار لاختبار سوق بورسيك من رومانيا إلى دبي."
    },
    privacy: {
      title: "الخصوصية — SOURCE / SAND",
      description: `كيفية تعامل ${sourceSand} مع إجابات اختبار السوق والموافقة على البريد الإلكتروني.`
    },
    notFound: {
      title: "الصفحة غير موجودة — SOURCE / SAND",
      description:
        "اختبار سوق مستقل في دبي لتحسين الوصول إلى مياه بورسيك المعدنية الطبيعية من رومانيا."
    }
  },
  dates: {
    unavailable: "التاريخ غير متاح",
    lastUpdated: "آخر تحديث"
  },
  hero: {
    title: "مياه معدنية أصيلة، من جبال الكاربات إلى دبي.",
    lede:
      "نختبر ما إذا كانت دبي تريد وصولاً أسهل وموثوقاً إلى بورسيك—المياه المعدنية الطبيعية من رومانيا—بالعبوات والأسعار التي سيشتريها الناس فعلاً.",
    primaryAction: "أود شربها",
    secondaryAction: "تعرّف إلى مكوّنات المياه",
    imageAlt:
      "تصوّر لزجاجة بورسيك باردة بين جدول في جبال الكاربات وكثبان صحراوية",
    imageCaption: "تصوّر للمنتج لأغراض أبحاث السوق",
    independent: "اختبار سوق مستقل",
    disclosure: "غير تابع لبورسيك أو مجموعة روماكوا ولا يحظى بتأييدهما"
  },
  water: {
    introTitle: "مياه لها مكان معروف في العالم.",
    introBody:
      "تُحلّى مياه شبكة دبي وتُعالج وفق معايير صارمة لمياه الشرب. أما المياه المعدنية الطبيعية فلها طبيعة مختلفة: تأتي معادنها الذائبة وخصائصها من مصدر جوفي محدد.",
    desalinationFactLabel: "معلومة عن تحلية المياه في دبي",
    statUnit: "مليون غالون إمبراطوري يومياً",
    statBody: "الطاقة المركبة لتحلية المياه في دبي عام 2025.",
    dewaReport: "تقرير الاستدامة 2025 لهيئة كهرباء ومياه دبي",
    dubaiPathTitle: "مياه دبي",
    dubaiPath: ["البحر", "التحلية", "المعالجة", "الشبكة"],
    borsecPathTitle: "مياه بورسيك المعدنية",
    borsecPath: ["المطر والثلج", "صخور الكاربات", "المصدر الجوفي", "التعبئة عند المصدر"],
    originNote:
      "هذا اختيار يتعلق بالمذاق والمنشأ، وليس ادعاءً بأن إمدادات دبي غير آمنة. وتؤكد هيئة كهرباء ومياه دبي أن مياه الشرب لديها تستوفي متطلبات منظمة الصحة العالمية الحالية.",
    mineralsTitle: "اقرأ الملصق، لا المبالغات.",
    mineralsBody:
      "تعرض نشرة فنية لعام 2024 لمياه بورسيك المكربنة طبيعياً التركيب أدناه. تختلف القيم الدقيقة باختلاف المصدر والمنتج، ويجب أن يكون الملصق المسجل في الإمارات هو المرجع النهائي.",
    mineralAnalysisLabel: "تحليل معادن مياه بورسيك",
    mineralLabels: {
      Bicarbonate: "بيكربونات",
      Calcium: "كالسيوم",
      Magnesium: "مغنيسيوم",
      Sodium: "صوديوم"
    },
    sourceNote:
      "النشرة الفنية لمياه بورسيك المكربنة طبيعياً، مراجعة 8 أبريل 2024. ينبغي إعادة التحقق من التركيب وفق المنتج المحدد المعتمد في الإمارات.",
    sourceLink: "اطّلع على معلومات مصدر بورسيك",
    imageAlt: "كأس مياه معدنية فوّارة على صخرة مبللة بجوار جدول"
  },
  journey: {
    title: "مصدر واحد. ومسافة طويلة إلى ثلاجتك.",
    body:
      "قد تبدأ الشحنة من بورسيك، وتعبر أوروبا إلى الميناء، ثم تمر عبر مسار السويس لتصل إلى جبل علي. قبل نقل منصة واحدة، نريد أن نعرف ما الذي ستشتريه دبي فعلاً.",
    mapLabel: "مسار توضيحي من بورسيك إلى دبي",
    mapTitle: "مسار توضيحي من بورسيك عبر كونستانتسا والسويس إلى جبل علي",
    stops: [
      { name: "بورسيك", detail: "هارغيتا، رومانيا" },
      { name: "كونستانتسا", detail: "ميناء توضيحي" },
      { name: "السويس", detail: "مسار بحري" },
      { name: "جبل علي", detail: "دبي، الإمارات" }
    ],
    routeNote: "مسار توضيحي · لم تُحسم الخدمات اللوجستية واختيارات الموانئ بعد",
    signalCount: "4 مؤشرات",
    signalSummary: "العبوة والسعر والاهتمام بالتذوق ونية الشراء المتكرر.",
    demandTitle: "يمكن تصور المسار. لكن الطلب لا يزال بحاجة إلى إثبات.",
    demandBody:
      "قبل نقل أي منصة، يجب أن يوضح هذا الاختبار ما الذي سيطلبه الناس، وما العبوات التي يفضلونها، وما سعر التوصيل المعقول، وهل سيتحول الاهتمام إلى عادة شراء متكررة.",
    addSignal: "أضف مؤشرك",
    sourceNote: "بحث مستقل عن الطلب · لا طلبات شراء ولا مدفوعات"
  },
  validation: {
    title: "ساهم في تشكيل طريقة أفضل لشرائها.",
    lede:
      "أخبرنا بما ستطلبه فعلاً. لا دفع ولا رسائل مزعجة—بل مؤشر أدق من مجرد إعجاب.",
    measuresTitle: "ما الذي سنقيسه",
    measures: ["اهتمام مؤهل", "قبول السعر", "العبوة المفضلة", "نية الشراء المتكرر"],
    usefulSignalTitle: "ما الذي يُعد مؤشراً مفيداً؟",
    usefulSignalBody:
      "الاستجابة الحقيقية للسعر وطلب التذوق ونية الشراء المتكرر أهم من نمو القائمة البريدية. وسنقيس شاربي بورسيك الحاليين والمشترين لأول مرة كلٌ على حدة."
  },
  interestForm: {
    legends: {
      buyer: "أشتري من أجل",
      familiarity: "علاقتي ببورسيك",
      water: "بورسيك التي أفضلها",
      format: "العبوة المفضلة",
      priceBefore: "هل ستطلب مسبقاً صندوقاً من ",
      priceBetween: " بسعر ",
      priceAfter: "؟",
      frequency: "كم مرة قد تناسبك؟"
    },
    options: {
      buyer: [
        { value: "home", label: "المنزل" },
        { value: "office", label: "المكتب" },
        { value: "hospitality", label: "مطعم / فندق" },
        { value: "retail", label: "متجر تجزئة" }
      ],
      familiarity: [
        { value: "regular", label: "أشتريها بالفعل" },
        { value: "tried", label: "جرّبتها" },
        { value: "aware", label: "أعرف الاسم" },
        { value: "new", label: "جديدة عليّ" }
      ],
      water: [
        { value: "sparkling", label: "فوّارة" },
        { value: "still", label: "غير فوّارة" },
        { value: "both", label: "كلاهما" }
      ],
      format: [
        { value: "glass", label: "زجاج" },
        { value: "pet", label: pet },
        { value: "either", label: "أي منهما" }
      ],
      price: [
        { value: "yes", label: "نعم" },
        { value: "maybe", label: "ربما" },
        { value: "no", label: "ليس بهذا السعر" }
      ],
      frequency: [
        { value: "weekly", label: "أسبوعياً" },
        { value: "monthly", label: "شهرياً" },
        { value: "occasionally", label: "من حين لآخر" },
        { value: "tasting", label: "أتذوق أولاً" }
      ]
    },
    priceQualifier:
      "اختبار افتراضي لسعر التوصيل المباشر. لم تُحسم العبوة والتكلفة النهائية والتوافر بعد.",
    email: "البريد الإلكتروني",
    emailPlaceholder: "name@example.com",
    area: "المنطقة في دبي",
    optional: "اختياري",
    areaPlaceholder: "مثلاً: مارينا",
    contactConsent: "راسلني بشأن جلسات التذوق والتوافر واختبار السوق هذا.",
    marketingConsent: `أرسل لي أيضاً ملاحظات ${sourceSand} عن المياه من حين لآخر. اختياري.`,
    saving: "جارٍ حفظ مؤشرك…",
    submit: "انضم إلى قائمة التذوق",
    footnote: "اختبار سوق مستقل · لا تُقبل طلبات شراء أو مدفوعات اليوم.",
    successTitle: "أصبحت في قائمة التذوق.",
    successBody:
      "شكراً لك. سنستخدم إجابتك عن العبوة والسعر لتقييم جدوى تجربة فعلية، ولن نراسلك إلا ضمن الأذونات التي اخترتها.",
    successAction: "اقرأ ملاحظات المياه",
    errors: {
      verificationExpired: "انتهت صلاحية التحقق البشري. يرجى إتمامه مرة أخرى.",
      verificationLoad: "تعذر تحميل التحقق البشري. تحقق من اتصالك وحاول مجدداً.",
      verificationMisconfigured:
        "نموذج الاهتمام غير متاح مؤقتاً ريثما يكتمل إعداد التحقق.",
      emailRequired: "أضف بريدك الإلكتروني كي نتواصل معك بشأن اختبار السوق.",
      emailInvalid: "أدخل عنوان بريد إلكتروني صالحاً ثم حاول مجدداً.",
      consentRequired: "أكد موافقتك على تواصلنا معك بشأن اختبار السوق.",
      verificationRequired: "أكمل التحقق البشري ثم حاول مجدداً.",
      verificationFailed: "فشل التحقق البشري. حدّث الصفحة وحاول مجدداً.",
      saveFailed: "تعذر حفظ إجابتك. يرجى المحاولة بعد قليل.",
      network: "تعذر الوصول إلى خدمة اختبار السوق. تحقق من اتصالك وحاول مجدداً.",
      invalidRequest: "لم تُقبل بعض تفاصيل النموذج. راجعها ثم حاول مجدداً.",
      conflict: "تغيّرت هذه الإجابة بعد إرسالها. حدّث الصفحة وحاول مجدداً."
    }
  },
  faq: {
    title: "إجابات واضحة.",
    items: [
      {
        question: "ماذا يحدث إذا أبدى عدد كافٍ من الناس اهتمامهم؟",
        answer:
          "سنستخدم المؤشرات لتحديد ما إذا كنا سنمضي في جلسات التذوق ومناقشات الموردين ودراسة الاستيراد وتجربة ملتزمة بالمتطلبات. لا تُقبل الآن طلبات شراء أو مدفوعات."
      },
      {
        question: "هل أنتم تابعون لبورسيك؟",
        answer: `لا. ${sourceSand} مشروع مستقل لاختبار السوق، ولا يملك حالياً اتفاقية توزيع.`
      },
      {
        question: "هل تقبلون طلبات شراء؟",
        answer:
          "ليس بعد. نجمع اهتماماً مؤهلاً وطلبات تذوق قبل اتخاذ أي خطوة تجارية."
      },
      {
        question: "هل مياه دبي غير آمنة؟",
        answer:
          "لا. تؤكد هيئة كهرباء ومياه دبي أن مياه الشرب لديها تستوفي متطلبات منظمة الصحة العالمية الحالية. يركز هذا المشروع على المذاق ومنشأ المصدر."
      }
    ]
  },
  finalCta: {
    title: "هل ستفسح لها مكاناً في الثلاجة؟",
    body:
      "امنحنا دقيقتين. ستحدد إجاباتك عن العبوة والسعر ونية الشراء ما إذا كان المشروع سيستمر.",
    join: "انضم إلى قائمة التذوق",
    trade: "أنا مشترٍ تجاري"
  },
  footer: {
    navigationLabel: "روابط تذييل الصفحة",
    research: "البحث",
    journal: "اليوميات",
    privacy: "الخصوصية",
    contact: "تواصل معنا",
    disclosure:
      "اختبار سوق مستقل · غير تابع لبورسيك أو مجموعة روماكوا ولا يحظى بتأييدهما.",
    location: "دبي، الإمارات العربية المتحدة"
  },
  research: {
    title: "ما الذي سيجعل هذا المشروع حقيقياً؟",
    intro:
      "ليس عدد الزيارات ولا المجاملات، بل مزيج موثوق من تفضيل المذاق وقبول السعر ونية الشراء المتكرر وإمداد ملتزم بالمتطلبات واقتصاديات قابلة للتطبيق.",
    hypothesisLabel: "الفرضية الحالية",
    hypothesisBody:
      "قد تدعم دبي عرضاً لبورسيك يركز على المنشأ، بدءاً بالجالية والتوصيل المنزلي المتميز وقطاع الضيافة.",
    gatesTitle: "معايير قرار متفق عليها مسبقاً",
    gatesBody:
      "هذه عتبات خاصة بالمشروع وليست معايير مرجعية للقطاع. تحديدها قبل الحملة يمنع تحويل قائمة انتظار مشجعة إلى مبرر تجاري بلا دليل.",
    metrics: [
      {
        value: "1,000",
        label: "جلسة مؤهلة من الإمارات",
        note: "وصول كافٍ لفصل النمط الحقيقي عن زيارات الأصدقاء والعائلة"
      },
      {
        value: "150+",
        label: "إجابة مكتملة",
        note: "مع فصل شاربي بورسيك الحاليين عن المشترين لأول مرة في النتائج"
      },
      {
        value: "3%",
        label: "تحويل عالي النية",
        note: "طلب تذوق أو حجز بسعر معروض قابل للتطبيق، لا مجرد بريد إلكتروني"
      },
      {
        value: "3",
        label: `تجارب ${b2b} مكتوبة`,
        note: "تتضمن التوقيت والعبوة والحجم الشهري المتوقع"
      }
    ],
    testTitle: "ما الذي سنختبره",
    tests: [
      {
        title: "المذاق والمنشأ",
        body: "هل تستطيع بورسيك كسب التفضيل من دون ادعاءات تثير الخوف بشأن المياه المحلية؟"
      },
      {
        title: "عبوات واقعية",
        body: `غير فوّارة أو فوّارة، زجاج أو ${pet}، صندوق منزلي أو زجاجة للضيافة.`
      },
      {
        title: "سعر قابل للتطبيق",
        body: "هل يلتزم الناس عندما يتضمن السؤال سعراً معقولاً لتوصيل الصندوق؟"
      },
      {
        title: "سلوك الشراء المتكرر",
        body: "هل هو حنين وفضول، أم عادة شراء أسبوعية أو شهرية؟"
      }
    ],
    guardrailsTitle: "ما الذي لن ندعيه",
    guardrails: [
      "لا نستخدم عبارات أكثر أماناً أو نقاءً أو تفوقاً في الترطيب.",
      "لا نقدم ادعاءات طبية أو عن الهضم أو إزالة السموم أو الأمراض.",
      "لا نوحي بأن مياه شبكة دبي غير آمنة.",
      "لا ندعي أنها «الأولى في الإمارات» ولا نصنع ندرة مصطنعة.",
      "لا ندعي وجود تفويض أو توزيع ما لم توجد اتفاقية.",
      "لا ندعي تفوقاً بيئياً من دون قياس أدلة النقل والتغليف."
    ],
    sourcesTitle: "مكتبة المصادر",
    sourcesBody:
      "نتعمد أن تكون ادعاءات هذا الموقع محدودة، ونربطها قدر الإمكان بمصادر أولية أو موثوقة وحديثة.",
    sources: [
      {
        label: "قائمة الاتحاد الأوروبي للمياه المعدنية الطبيعية المعترف بها، يونيو 2026",
        href: "https://food.ec.europa.eu/document/download/ec4fbcc0-7185-4dce-820a-27f7e2653dad_en?filename=labelling-nutrition_mineral-waters_list_eu-recognised.pdf"
      },
      {
        label: "مجموعة روماكوا: تاريخ بورسيك ومنشؤها",
        href: "https://romaqua-group.ro/en/brands/borsec/"
      },
      {
        label: "تقرير الاستدامة 2025 لهيئة كهرباء ومياه دبي",
        href: "https://www.dewa.gov.ae/-/media/Files/Sustainability/Sustainability_Report_English_2025.ashx"
      },
      {
        label: "خدمات الأغذية في بلدية دبي",
        href: "https://www.dm.gov.ae/dubai-municipality-services/"
      },
      {
        label: "مسح مستهلكي المياه المعبأة في الإمارات لعام 2022",
        href: "https://www.mdpi.com/2071-1050/14/5/2664"
      }
    ]
  },
  privacy: {
    title: "الخصوصية، بلغة واضحة.",
    lede:
      `${sourceSand} مشروع مستقل لأبحاث السوق. لا نجمع إلا ما يلزم لفهم الطلب، وللتواصل معك بشأن جلسات التذوق أو التوافر إذا طلبت ذلك.`,
    collectTitle: "ما الذي نجمعه",
    collectBody:
      "بريدك الإلكتروني، والمنطقة العامة في دبي، وتفضيلات المياه والعبوة، واستجابتك لسعر معروض، وتكرار الشراء المتوقع، ونوع المشتري، ومدى معرفتك ببورسيك، وخيارات الموافقة، وبيانات أساسية عن مصدر الحملة. لا نطلب عنوان منزلك الدقيق أو جنسيتك أو معلومات صحية أو بيانات دفع أو وثائق هوية.",
    useTitle: "لماذا نستخدمه",
    useBody:
      "لقياس الاهتمام المؤهل، ودعوة من وافقوا إلى جلسات التذوق، وفهم تفضيلات السعر والعبوة، وتحديد جدوى تجربة إمداد ملتزمة بالمتطلبات. إذن استلام اليوميات اختياري ومنفصل عن إذن التواصل البحثي.",
    storageTitle: "التخزين والوصول",
    storageBody:
      `تُخزن الإجابات في قاعدة بيانات ${cloudflareD1}. ولا يُرسل إشعار العملاء المحتملين إلا إلى صندوق بريد المشروع الموثق. لا نخزن عناوين بروتوكول الإنترنت الخام. وقد نحتفظ برمز الدولة ومركز بيانات كلاودفلير لإجراء فحوص عامة على جودة الزيارات.`,
    retentionTitle: "مدة الاحتفاظ وخياراتك",
    retentionBody:
      "نحتفظ بإجابات البحث لمدة تصل إلى 12 شهراً، ما لم توجد حاجة مشروعة للاحتفاظ بإجمالي مجهّل الهوية. يمكنك طلب الوصول إلى إجابتك أو تصحيحها أو حذفها أو إيقاف أي بريد مستقبلي عبر الكتابة إلى",
    statusTitle: "الصفة المستقلة",
    statusBody:
      "هذا المشروع غير تابع لبورسيك أو مجموعة روماكوا ولا يحظى بتأييدهما. وإذا تسلم شريك تجاري المشروع، فسنحدّث هذا الإشعار قبل استخدام البيانات لغرض مختلف جوهرياً."
  },
  notFound: {
    eyebrow: "404 · خارج المسار",
    title: "تبخرت هذه الصفحة.",
    body: "جرّب اختبار السوق أو ملاحظات البحث أو اليوميات بدلاً منها.",
    back: "العودة إلى SOURCE / SAND"
  },
  blog: {
    common: {
      minuteShort: "دقيقة",
      minutes: (count) => {
        const formatted = count.toLocaleString("ar-AE");
        if (count === 1) return "دقيقة واحدة";
        if (count === 2) return "دقيقتان";
        return `${formatted} دقائق`;
      },
      readNote: "اقرأ الملاحظة"
    },
    preview: {
      title: "ملاحظات عن المياه، بعيداً عن ضباب العافية.",
      intro:
        "قراءات قصيرة وموثقة عن المياه المعدنية والمذاق ونظام مياه دبي والمسار العملي من الاهتمام إلى الاستيراد.",
      readAll: "اقرأ كل الملاحظات",
      empty: "لا توجد ملاحظات منشورة عن المياه بعد.",
      unavailable: "الملاحظات المترجمة غير متاحة مؤقتاً."
    },
    index: {
      title: "المياه، من مصادرها.",
      intro:
        "ملصقات المعادن والمصادر الرومانية ونظام مياه دبي وواقع الاستيراد والمذاق—بمراجع موثقة ومن دون استعراض طبي.",
      ruleLabel: "قاعدة التحرير 01",
      ruleBody: "سؤال بحث واحد. اعتراض مشترٍ واحد. خطوة تالية صادقة واحدة.",
      read: "اقرأ"
    },
    article: {
      allNotes: "كل الملاحظات",
      sourcesTitle: "المصادر",
      sourcesIntro: "المراجع الأساسية المستخدمة في هذه الملاحظة. آخر مراجعة",
      notFoundEyebrow: "404 · ملاحظة مفقودة",
      notFoundTitle: "تعذر العثور على ملاحظة المياه هذه.",
      notFoundBody: "قد يكون العنوان قديماً، أو ربما لم تُنشر المسودة.",
      backToJournal: "العودة إلى اليوميات",
      outageEyebrow: "انقطع الاتصال",
      outageTitle: "الملاحظة بعيدة المنال مؤقتاً.",
      outageBody: "تحقق من اتصالك وحاول مجدداً. هذه ليست نتيجة «غير موجود» دائمة.",
      tryAgain: "حاول مجدداً",
      loading: "جارٍ تحميل ملاحظة المياه…",
      visualsLabel: "الصورة التوضيحية للمقال"
    },
    categories: {
      "Mineral water": "مياه معدنية",
      "Dubai water": "مياه دبي",
      "Import diary": "يوميات الاستيراد",
      "Market case study": "دراسة حالة سوقية"
    }
  }
} satisfies MessageCatalog;
